import React from "react";
import { ContentSection, Grid, GridColumn, GridRow, LabeledText } from "sprint-common-web";

import { useGetOnPremOrderDashboard } from "../hooks/useGetOnPremOrderDashboard";

interface OnPremOrderMaterialSpecificationSectionProps {
    minHeight: number;
}

export const OnPremOrderMaterialSpecificationSection: React.VFC<OnPremOrderMaterialSpecificationSectionProps> = ({
    minHeight
}: OnPremOrderMaterialSpecificationSectionProps) => {
    const { isLoading, onPremOrderDetails } = useGetOnPremOrderDashboard();

    return (
        <ContentSection
            header="Material specification"
            style={{ minHeight, flex: 1 }}
            isLoading={isLoading}
            testId={"onprem-material-specification-section"}
        >
            <Grid>
                <GridRow>
                    <GridColumn lg={6}>
                        <LabeledText
                            label="Encoding format"
                            testId="onprem-order-encodingFormat"
                            value={onPremOrderDetails.materialSpecification?.encodingFormat}
                        />
                        <LabeledText
                            label="Aspect ratio"
                            testId="onprem-order-aspectRatio"
                            value={onPremOrderDetails.materialSpecification?.aspectRatio}
                        />
                        <LabeledText
                            label="Runtime"
                            testId="onprem-order-runtime"
                            value={onPremOrderDetails.materialSpecification?.runtime}
                        />
                    </GridColumn>
                    <GridColumn lg={6}>
                        <LabeledText
                            label="Bit rate"
                            testId="onprem-order-bitRate"
                            value={onPremOrderDetails.materialSpecification?.bitRate}
                        />
                        <LabeledText
                            label="Resolution"
                            testId="onprem-order-resolution"
                            value={onPremOrderDetails.materialSpecification?.resolution}
                        />
                        <LabeledText
                            label="Notes"
                            testId="onprem-order-notes"
                            value={onPremOrderDetails.notes}
                            nowrap={false}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};
